import { useMemo } from "react";
import { useWebMainFirstQuery } from "./WebMain";

export default function useCuration() {
  const homeFirstQuery = useWebMainFirstQuery();

  const curationItems = useMemo(() => {
    const curations = homeFirstQuery.data?.curations;
    return Array.isArray(curations) ? curations : [];
  }, [homeFirstQuery.data]);

  return {
    ...homeFirstQuery,
    data: curationItems,
  };
}
